export default "__VITE_ASSET__CiMve33n__"